/** Extracts the country and language portion of a path if possible. */
export const extractMarketNameFromPath = (path = ''): string => {
    const matchArray = path.match(/\/\w{2}\/\w{2}\//g) || []; // e.g. [/us/en/]
    return matchArray[0]?.replace(/\//g, '') || '';
};
